// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1772d239","418":"fbc9419e","486":"83518120","488":"e7222a66","597":"6ee8f1c2","622":"f22ddb19","694":"67fdb23e","782":"49c860b5","810":"6f70f045","937":"ca68b431"}[chunkId] + ".chunk.js";
};